var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.33333C11.676 1.33333 14.6667 4.324 14.6667 8C14.6667 11.676 11.676 14.6667 8 14.6667C4.324 14.6667 1.33333 11.676 1.33333 8C1.33333 4.324 4.324 1.33333 8 1.33333ZM8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM6.64467 10.6733C7.02067 9.48067 7.73267 8.052 7.85867 7.69067C8.04067 7.166 7.718 6.93333 6.69867 7.83L6.472 7.40333C7.63467 6.13867 10.0287 5.85267 9.214 7.812C8.70533 9.03533 8.34133 9.86133 8.13333 10.4987C7.83 11.4273 8.596 11.0507 9.346 10.358C9.448 10.5247 9.48133 10.5787 9.58333 10.7707C7.918 12.356 6.06933 12.496 6.64467 10.6733ZM9.806 5.22733C9.45133 5.52933 8.926 5.52267 8.632 5.21267C8.338 4.90267 8.38733 4.40733 8.74133 4.10533C9.096 3.80333 9.62133 3.81067 9.91533 4.12C10.208 4.43067 10.16 4.926 9.806 5.22733Z",
    fill: "#FF9100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.165309896abb2b2f4ce6a61fc6c7daf8.svg";
export { ForwardRef as ReactComponent };